<nb-card class="bg-transparent">
  <nb-card-header class="pb-0">
    <div class="row">
        <div class="col-lg-4 col-12 text-start">
          <h4 class="fw-semibold ls-1">Room List</h4>
        </div>
        <div class="col-lg-8 col-12">
            <div class="d-flex justify-content-end">
              <button (click)="addRoomClicked()" mat-raised-button class="new-compact-btn" color="primary">
                    <span class="fa-icon-wrapper"><i class="fas fa-plus me-2"></i></span>
                    New Room
                </button>
            </div>
        </div>
    </div> 
    <nb-card class="mt-4 bg-transparent border-0">
      <nb-card-body class="shadow bg-white grid-wrapper">     
        <div class="row pb-2">
          <div class="col">
            <kw-filter-dropdown (filterResultsChange)="search($event)" 
            [gridCountDataAndMessage]="gridMessageAndCount"
            [filterSettings]="this.filterSettings"></kw-filter-dropdown>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
    <!-- <div class="container-fluid p-0">
        <div class="row px-4">
            <div class="col-lg-12 col-12">               
                <div class="card custom-card">
                    <div class="custom-card-header">
                        <h5><i class="fas fa-filter me-2" style="color:#253d5b;"></i>Filters</h5>
                        <div class="d-flex justify-content-end">
                                  </div>
                    </div>
                    <div class="card-body custom-card-body">
                        <div class="row">
                            <div class="col-lg-12 col-12">
                                <kw-filter-dropdown (filterResultsChange)="search($event)" [filterSettings]="this.filterSettings"></kw-filter-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
  </nb-card-header>
  <nb-card-body>
    <div class="grid-wrapper">
    <div class="mat-elevation-z2 table-scroll" [nbSpinner]="roomLoading">
            <table mat-table class="full-width-table" [dataSource]="dataSource" matSort aria-label="Elements">
              <!-- Id Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Id</th>
                <td mat-cell *matCellDef="let row">{{row.id}}</td>
              </ng-container>
      
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Room</th>
                <td mat-cell *matCellDef="let row">{{row.name}}</td>
              </ng-container>
              <ng-container matColumnDef="roomDescription">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Room Description</th>
                <td mat-cell *matCellDef="let row">{{row.description}}</td>
              </ng-container>
              <ng-container matColumnDef="roomCapacity">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Room Capacity</th>
                <td mat-cell *matCellDef="let row">{{row.roomCapacity}}</td>
              </ng-container>
              <ng-container matColumnDef="warehouse">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Warehouse</th>
                <td mat-cell *matCellDef="let row">{{row.warehouse.name}}</td>
              </ng-container>
              <ng-container matColumnDef="integrationId">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Integration Id</th>
                <td mat-cell *matCellDef="let row">{{row.integrationId}}</td>
              </ng-container>
      
              <ng-container matColumnDef="status">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let row">{{this.getStatus(row)}}</td>
              </ng-container>
      
              <ng-container matColumnDef="barcode">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Barcode</th>
                <td mat-cell *matCellDef="let row">{{row.barcode}}</td>
              </ng-container>
      
              <ng-container matColumnDef="{{x.name}}" *ngFor="let x of this.filteredDetails">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef>{{x.name}}</th>
                <td class="columnPadding
                    min-width" mat-cell *matCellDef="let row">{{getValue(row, x.id) || ""}}</td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>
      
              <ng-container matColumnDef="isActive">
                <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Is Active</th>
                <td mat-cell *matCellDef="let row">
                  <div *ngIf="row.isActive === true" style="color: green;">
                    <fa-icon [icon]="faCheck"></fa-icon>
                  </div>
                  <div *ngIf="row.isActive === false" style="color: darkRed">
                    <fa-icon [icon]="faTimes"></fa-icon>
                  </div>
                </td>
              </ng-container>
      
              <!-- Edit Column -->
              <ng-container matColumnDef="edit">
                <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
                <td mat-cell *matCellDef="let row"><button mat-icon-button (click)="editClicked(row.id);"><i
                      class="fas fa-edit fa-lg"></i></button></td>
              </ng-container>
      
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
      
            <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="50"
              [pageSizeOptions]="[25, 50, 100, 250]">
            </mat-paginator>
    </div>
  </div>
  </nb-card-body>
</nb-card>